import { useTranslation } from 'react-i18next';
import { Dialog } from 'src/components/Dialog';
import { Theme, useMediaQuery } from 'src/components/muiTheme/utils';
import { PayBalanceContent } from 'src/shared/PayBalance/PayBalanceContent';

export function CheckinPayBalanceDialog({
  open,
  onClose,
  onPaymentResolved,
  userId,
}: {
  open: boolean;
  onClose: () => void;
  onPaymentResolved?: () => void;
  userId: string;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'payBalance' });
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('title')}
      fullScreen={isMobile}
      maxWidth="md"
    >
      <PayBalanceContent
        userId={userId}
        onPaymentSuccess={() => {
          onPaymentResolved?.();
          onClose();
        }}
      />
    </Dialog>
  );
}
